<template>
  <b-container>
    <h1>Review &amp; Submit</h1>
    <div class="jumbotron" v-show="submitted == false">
      <b-row>
        <h3>Student Information</h3>
      </b-row>
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <b>Name:</b>
          {{ bioDemo.firstName }} {{ bioDemo.lastName }}
          <br />
          <span v-show="bioDemo.previousName">
            <b>Preferred/Maiden Name:</b>
            {{bioDemo.previousName }}
            <br />
          </span>
          <b v-if="bioDemo.gender">Gender:</b>
          <span v-if="bioDemo.gender === 'M'">
            Male
            <br />
          </span>
          <span v-if="bioDemo.gender === 'F'">
            Female
            <br />
          </span>
          <span v-if="bioDemo.gender === 'O'">
            Other/Prefer not to disclose
            <br />
          </span>

          <address>
            {{ bioDemo.streetLineOne }}
            <br />
            {{ bioDemo.streetLineTwo }}
            <div v-if="bioDemo.streetLineTwo">
              <br />
            </div>
            {{ bioDemo.city}} {{bioDemo.state}}, {{bioDemo.zip}}
            <br />
            <b>Phone:</b>
            {{bioDemo.phoneNumber}}
            <br />
            <b>Email:</b>
            {{bioDemo.email}}
            <br />
            <b>Date of Birth:</b>
            {{bioDemo.birthDate}}
          </address>
        </b-col>
        <b-col sm="12" md="6" lg="6">
          <b>Degree Status:</b>
          <span v-if="bioDemo.collegeDegree == 'true'">College Degree</span>
          <span v-if="bioDemo.collegeDegree == 'false'">No College Degree</span>
          <br />
          <b>Ethnicity:</b>
          <span v-if="bioDemo.hispanic == 'true'">Hispanic</span>
          <span v-if="bioDemo.hispanic == 'false'">Non-Hispanic</span>
          <br />
          <b v-if="races.length > 1">Race:</b>
          <span v-if="ofRace('nativeAmerican')">
            American Indian or Alaska Native
            <br />
          </span>
          <span v-show="ofRace('asian')">
            Asian
            <br />
          </span>
          <span v-if="ofRace('black')">
            Black or African American
            <br />
          </span>
          <span v-if="ofRace('pacificIslander')">
            Native Hawaiian or Other Pacific Islander
            <br />
          </span>
          <span v-if="ofRace('white')">
            White
            <br />
          </span>
          <b>Registration Status:</b>
          <span v-if="bioDemo.registered == 'true'">Registered</span>
          <span v-if="bioDemo.registered == 'false'">Not Registered</span>
          <br />
          <span v-show="bioDemo.westernId != null">
            <b>Western ID:</b>
            {{ bioDemo.westernId }}
          </span>
          <br />
          <b>School District:</b>
          {{district}}
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <h3>Shopping Cart (${{cart.cost}})</h3>
        </b-col>
      </b-row>

      <div class="container" v-for="(course, index) in courses" :key="index">
        <Course :course="course"></Course>
      </div>

      <b-row>
        <b-col sm="12" md="4" v-show="cart == null">
          <router-link to="/">
            <b-button
              block
              variant="danger"
              class="d-block mt-2"
              size="block"
              type="submit"
            >Add Course(s)</b-button>
          </router-link>
        </b-col>
        <b-col sm="12" md="4" v-show="cart != null && ! bioDemo.firstName">
          <router-link to="/biodemo">
            <b-button
              block
              variant="danger"
              class="d-block mt-2"
              size="block"
              type="submit"
            >Complete Bio Demo Information</b-button>
          </router-link>
        </b-col>
        <b-col sm="12" md="4" v-show="cart != null && bioDemo.firstName">
          <router-link to="/cart">
            <b-button
              block
              variant="danger"
              class="d-block mt-2"
              size="block"
              type="submit"
            >Return to Cart</b-button>
          </router-link>
        </b-col>
        <b-col sm="12" md="4">
          <router-link to="/biodemo">
            <b-button
              block
              variant="danger"
              class="d-block mt-2"
              size="block"
              type="submit"
            >Edit Student Information</b-button>
          </router-link>
        </b-col>
        <b-col>
          <b-button
            variant="danger"
            class="btn-block d-block mt-2"
            v-on:click="register()"
            v-show="!error"
          >Submit Registration Request</b-button>
        </b-col>
      </b-row>
    </div>
    <div class="jumbotron" v-show="submitted == true">
      <b-row>
        <h3>Thank you your registration has been submitted.</h3>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mixins } from "../mixins";
import Course from "../components/course";

export default {
  name: "complete",
  components: {
    Course
  },
  data() {
    return {
      cart: {},
      courses: [],
      races: [],
      bioDemo: {},
      error: false,
      submitted: false,
      districts: [],
      district: null
    };
  },
  mixins: [mixins],
  created() {
    this.bioDemo.cartId = this.$store.getters.cartId;
    if (this.bioDemo.cartId == 0) {
      this.errorToast(
        "You need to add items to your cart before you can complete."
      );
    } else {
      this.getStudent();
      this.getCart();
      this.setDistrict();
    }
  },
  methods: {
    ofRace(testRace) {
      if (this.races.includes(testRace)) {
        return true;
      } else {
        return false;
      }
    },
    getStudent() {
      this.api
        .post("/getStudent", {
          cartId: this.bioDemo.cartId
        })
        .then(response => {
          if (response.data.student.firstName != undefined) {
            this.bioDemo = response.data.student;
            this.districts = response.data.districts;
            if (this.bioDemo.races != undefined) {
              this.races = this.bioDemo.races;
            }
            this.districts.forEach((rec) => {
              if (rec.districtId == this.bioDemo.districtId) {
                this.district = rec.label;
              }
            });
          } else {
            this.error = true;
            this.errorToast(
              "You need to fill our your bioDemo data before you complete."
            );
          }
        })
        .catch(error => {
          if (error.response != undefined) {
            if (error.response.data != undefined) {
              this.errorToast(
                error.response.data.message || error.message || ""
              );
            }
          } else {
            this.errorToast(error.message || "");
          }
        });
    },
    getCart() {
      this.api
        .post("/cart", {
          cartId: this.$store.getters.cartId
        })
        .then(response => {
          if (response.data.courses.length > 0) {
            this.cart = response.data;
            this.courses = response.data.courses;
          } else {
            this.error = true;
            this.errorToast("You do not have any courses in your cart.");
          }
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    register() {
      if (this.bioDemo.firstName.length < 1) {
        this.errorToast("You need to fill out your Student Information First.");
      } else if (this.cart.length < 1) {
        this.errorToast("You need to select at least one course first.");
      } else {
        this.api
          .post("/complete", {
            cartId: this.$store.getters.cartId
          })
          .then(() => {
            this.successToast("Information Saved");
            this.$store.commit("setCartId", 0);
            this.$store.commit("setBioDemoSubmitted", false);
            this.submitted = true;
            this.manageDiscountedCourses();
          })
          .catch(error => {
            this.errorToast(error.response.data.message || error.message || "");
          });
      }
    },
    manageDiscountedCourses() {
      this.api
        .post("/discountedCourseManager")
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    }
  }
};
</script>

<style scoped>
.CourseResults {
  width: 100% !important;
}
</style>
